exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#merchant-landing-page .text-input{width:200px}", ""]);

// exports
